/**
 * Merges two arrays by ID, preferring items from the next array when IDs match.
 * Items from the previous array that don't exist in the next array are kept,
 * and new items from the next array are appended.
 *
 * @param prev - Previous array (optional)
 * @param next - Next array with potentially updated or new items
 * @param getId - Function to extract the ID from an item for comparison
 * @returns Merged array with updated items from next and preserved items from prev
 */
const mergeById = <T>(prev: T[] | undefined, next: T[], getId: (item: T) => string): T[] => {
  if (!prev) return next;
  const used = new Set<number>();
  const merged = prev.map((item) => {
    const idx = next.findIndex((n) => getId(n) === getId(item));
    if (idx === -1) return { ...(item as any) };
    used.add(idx);
    return { ...(next[idx] as any) };
  });
  const additions = next.filter((_, i) => !used.has(i));
  return [...merged, ...additions];
};

export default mergeById;
